define('modules/shell/widgets/datepicker/i18n/translations',['./en',
    './de',
    './es',
    './fr',
    './he',
    './it',
    './ja'
], function (en, de, es, fr, he, it, ja) {
    return {
        en: en,
        de: de,
        es: es,
        fr: fr,
        he: he,
        it: it,
        ja: ja
    };
});

